/**
 * Сидированный ГПСЧ боя (mulberry32): только 32-битная целочисленная арифметика, одинаков в браузере и на Node.
 * Весь случайный выбор боя идёт через один поток в фиксированном порядке — состав волны, точки появления,
 * криты, действия боссов. Визуальные эффекты ГПСЧ не трогают.
 */
export interface Rng {
  /** Следующее беззнаковое 32-битное целое. */
  nextU32(): number;
  /** Целое в `[min, max]` включительно (`max ≥ min`). */
  int(min: number, max: number): number;
  /** Событие с вероятностью `permille / 1000`. */
  chance(permille: number): boolean;
  /** Внутреннее состояние — входит в хэш состояния боя. */
  state(): number;
}

export function createRng(seed: number): Rng {
  let s = seed >>> 0;
  const nextU32 = (): number => {
    s = (s + 0x6d2b79f5) >>> 0;
    let t = s;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return (t ^ (t >>> 14)) >>> 0;
  };
  return {
    nextU32,
    int(min, max) {
      if (max <= min) return min;
      return min + (nextU32() % (max - min + 1));
    },
    chance(permille) {
      if (permille <= 0) return false;
      if (permille >= 1000) return true;
      return nextU32() % 1000 < permille;
    },
    state: () => s,
  };
}
